import { APPARATURE } from '../../sagas/types';
import { createAction } from '../common';

export const postAddNewApparature = createAction(APPARATURE.ADD_NEW_APPARATURE);
export const getAllApparature = createAction(APPARATURE.GET_ALL_APPARATURE);
export const putUpdateApparature = createAction(APPARATURE.UPDATE_APPARATURE);
export const patchRemoveApparature = createAction(APPARATURE.REMOVE_APPARATURE);
